import React, { Component } from "react";
import Datamap from "datamaps";
import d3 from "d3";
// import CanadaJson from './Canada.topo.json';
// import performance from 'perf_hooks';

class USChloroplethMap extends Component {
  componentDidMount() {

    let dataset = {};
    let toolTipText = this.props.stats.toolTipText ? this.props.stats.toolTipText : "";
    let toolTipTextAfter = this.props.stats.toolTipTextAfter ? this.props.stats.toolTipTextAfter:"";

    let paletteScale = d3.scale
      .linear()
      .domain([this.props.stats.min, this.props.stats.max])
      // .range(["#CFEC9D", "#324F00"]); // blue color
      .range([this.props.stats.colorMin, this.props.stats.colorMax]);
    // var t0 = performance.now();
    
    for (let item in this.props.data) {
      // console.log(item, this.props.data[item]);
      if (this.props.data[item]) {
        //  console.log(item, this.props.data[item]);
        dataset[item] = {
          numberOfThings: this.props.data[item],
          fillColor: paletteScale(this.props.data[item])
        };
      }
    }
    
    // var t1 = performance.now();
    // console.log("fn took " + (t1 - t0) + " milliseconds.")
    const width = 1000;
    const scope = this.props.scope?this.props.scope:"usa";

    let map = new Datamap({
      element: document.getElementById("cloropleth_map"),
      projection: "mercator",
      scope: scope,
      responsive: true,
      // height:1000,
      // width: 1000,
      geographyConfig: {
        popupOnHover: true,
        highlightOnHover: true,
        borderColor: "#444",
        highlightBorderWidth: 3,
        borderWidth: 0.75,

        popupTemplate: function(geo, data) {
          if (!data) {
            return;
          }
          return [
            '<div class="hoverinfo">',
            "<strong>",
            geo.properties.name,
            "</strong>",
            `<br>${toolTipText}<strong>`,
            data.numberOfThings.toLocaleString(),
            "</strong>",
            toolTipTextAfter,
            "</div>"
          ].join("");
        }
      },
      fills: {
        HIGH: "#afafaf",
        LOW: "#123456",
        MEDIUM: "blue",
        UNKNOWN: "rgb(0,0,0)",
        defaultFill: "#eee"
      },
      data: dataset,
      // setProjection: function (element) {
      //     var projection = d3.geo.mercator()
      //         .center([-96, 38]) // always in [East Latitude, North Longitude]
      //         .scale(950)
      //         .translate([element.offsetWidth / 2, element.offsetHeight / 2]);

      //     var path = d3.geo.path().projection(projection);
      //     return { path: path, projection: projection };
      // }
    });
    map.labels();
    window.addEventListener('resize', function (event) {
      map.resize();
    });
  }
  render() {
    return <div id="cloropleth_map" />;
  }
}

export default USChloroplethMap;
